export default __webpack_public_path__ + "images/I3.27b6cba.png";